export class QFile {
  constructor() {
    this.fFileName = null;
    this.fModTime = null;
    this.fFileType = null;
    this.fFileMgrPanel = null;
    this.fFileMgr = null;
    this.fExtension = null;
    this.fFolder = null;
  }

  InitFile(fileInfo, parentFolder, fileMgr) {
    this.fFileMgr = fileMgr;
    this.fFileMgrPanel = fileMgr.fFileMgrPanel;
    this.fExtension = fileInfo["extension"];
    this.fFileName = fileInfo["filename"];
    this.fModTime = fileMgr.GetFileModificationDate(fileInfo["modtime"]);
    this.fModTimeRaw = fileInfo["modtime"];
    fileInfo.localModTime = this.fModTime;
    this.fFileType = fileInfo["type"];
    this.fFileSize = fileInfo["size"];
    this.fFolder = parentFolder;
    this.fileInfo = fileInfo;
    fileInfo.value = this;
    fileInfo["Actions"] = fileInfo;
    fileInfo["filePath"] = this.fFileName + "." + this.fExtension;
  }

  GetParentFolder() {
    return this.fFolder;
  }

  GetFileExt() {
    return this.fExtension;
  }

  IsChartDocument() {
    return this.fExtension === "oc5" || this.fExtension === "ocd" || this.fExtension === "temp";
  }

  IsBackground() {
    return this.fExtension === "ocb" || this.fExtension === "oc5m";
  }

  GetFileName(fullName) {
    if (fullName) return this.PGetFullName();
    else return this.fFileName;
  }

  PGetFullName() {
    if (this.fExtension.length > 0) return this.fFileName + "." + this.fExtension;
    else return this.fFileName;
  }

  SetFileName(fileName) {
    this.fFileName = fileName;
  }
}
